/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description Back Button Component
 */
import { Button, ButtonProps } from 'antd';

/**
 * Back Button Component
 * Navigates to previous page if it exists, otherwise to home path
 */
const GoBack: React.FC<ButtonProps> = ({ ...props }) => {
	return (
		<Button onClick={() => history.back()} {...props}>
			{props.children || 'Go Back'}
		</Button>
	);
};

export default GoBack;
